import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import useUrlSearchParams from '@/hooks/useUrlSearchParams'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getPolicies } from '../../../services'
import { getPolicyColumns } from './columns'
import { Policy } from '../../../types'
import ExpandedPolicyDetail from './expanded-policy-detail'

const PoliciesList = () => {
    const { t } = useTranslation()

    const { queryParams, searchInputProps } = useUrlSearchParams()

    const apiParams = useMemo(
        () => ({
            name: queryParams.q || undefined,
            max: 1000,
        }),
        [queryParams.q]
    )

    const {
        data: policiesData,
        renderState,
        isFetching,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.AUTHORIZATION_POLICIES, apiParams],
            queryFn: () => getPolicies(apiParams),
            placeholderData: true,
        },
        { showLoading: true, showError: true }
    )

    const rows = policiesData?.results || []
    const columns = useMemo(() => getPolicyColumns(), [])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Paper>
            <DataTableCustomized<Policy>
                columns={columns}
                rows={rows}
                rowKey={(row) => row.id}
                isFetching={isFetching}
                emptyMessage={t('noData', 'Không có dữ liệu')}
                pagination={{
                    page: 1,
                    pageSize: 20,
                    total: rows.length,
                }}
                toolbar={{
                    search: {
                        ...searchInputProps,
                        placeholder: t('search'),
                    },
                }}
                expandable={{
                    expandedRowRender: (row) => (
                        <ExpandedPolicyDetail row={row} />
                    ),
                    rowExpandable: (row) =>
                        ['role', 'user', 'group'].includes(row.type),
                }}
                bordered
            />
        </Paper>
    )
}

export default PoliciesList
